
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/rEditor/rootComps/loaderOnStage/styles.scss.css.virtualfile';
        module.exports = {"panel":"_panel_ubc2l_7"};